module.exports = __webpack_public_path__ + "img/calaberas.0b2039ca.svg";